module.exports = __webpack_public_path__ + "assets/img/36_1503.21acc33f.jpg";